import React, { useRef, useEffect } from 'react';


type DeviceControlItem = {
  title: string
  open: boolean
  onOpen(open: boolean): void
  style?: React.CSSProperties
}
/**
 * 计数按钮
 */


function DeviceControlItem(props: DeviceControlItem) {
  const colorOn = '#597F42'
  const colorOff = '#8F392F'

  return (
    <div
      style={{
        borderRadius: 10,
        padding: 16,
        ...props.style || {},
      }}
    >
      <div
        className='flex'
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <span
          style={{
            fontSize: 18,
            fontWeight: '700',
            color: 'rgba(0,0,0,0.7)',
          }}
        >{props.title}</span>
        <div
          style={{
            fontSize: 12,
            fontWeight: '700',
            color: props.open ? '#65895C' : '#8E0300',
            backgroundColor: props.open ? '#EBF4EB' : '#F8EDEC',
            padding: '4px 10px',
            borderRadius: 20,
          }}
        >
          {props.open ? 'ON' : 'OFF'}
        </div>
      </div>
      <div
        className='flex'
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: 15,
        }}
      >
        {['ON', 'OFF'].map((item, index) => {
          const disabled = props.open ? item === 'ON' : item === 'OFF'
          return (
            <button
              key={index}
              onClick={() => {
                props.onOpen(!!!props.open)
              }}
              disabled={disabled}
              style={{
                width: '48%',
                opacity: disabled ? 0.7 : 1,
                backgroundColor: item === 'ON' ? colorOn : colorOff,
                borderRadius: 5,
                color: 'white',
                fontSize: 15,
                fontWeight: '700',
                textAlign: 'center',
                padding: '8px 0px',
              }}
            >
              {item}
            </button>
          )
        })}
      </div>
    </div>
  );
}

export default DeviceControlItem;
